import Vue from 'vue'
import componentLoader from '@/utils/componentLoader'

// 定义核心组件列表 - 这些组件在应用启动时就需要
const criticalComponents = [
  'NavBar',
  'FooterBar',
  'FooterCommon',
  'PyLoading',
  'Icon',
  'BottomPopupDialog',
  'LeftPopupDialog'
]

// 立即注册核心组件
const requireComponent = require.context(
  '.',
  true,
  /\.vue$/
)

const allComponents = {}

// 收集所有组件
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName = fileName.split('/')[1]
  allComponents[componentName] = componentConfig.default || componentConfig
})

// 立即注册核心组件
criticalComponents.forEach(componentName => {
  if (allComponents[componentName]) {
    Vue.component(componentName, allComponents[componentName])
  }
})

// 标记核心全局组件已加载
componentLoader.loadedComponents.add('global-base')

// 延迟注册非核心组件
const registerNonCriticalComponents = () => {
  Object.keys(allComponents).forEach(componentName => {
    if (!criticalComponents.includes(componentName)) {
      Vue.component(componentName, allComponents[componentName])
    }
  })

  // 标记非核心组件已加载
  componentLoader.loadedComponents.add('global-popup')
  console.log('非核心全局组件注册完成')
}

// 创建加载承诺
const loadNonCriticalComponents = () => {
  return new Promise((resolve) => {
    registerNonCriticalComponents()
    resolve()
  })
}

// 根据当前路由决定加载策略
const shouldLoadPopupsImmediately = () => {
  const path = window.location.pathname
  return path.includes('cart') ||
         path.includes('product-detail') ||
         path.includes('payment') ||
         path.includes('contact-details') ||
         path.includes('contact_details')
}

// 注册延迟加载
if (shouldLoadPopupsImmediately()) {
  // 关键页面立即加载
  const promise = loadNonCriticalComponents()
  componentLoader.registerLoadingPromise('global-popup', promise)
} else {
  // 非关键页面延迟加载
  const promise = new Promise((resolve) => {
    setTimeout(() => {
      registerNonCriticalComponents()
      resolve()
    }, 800)
  })
  componentLoader.registerLoadingPromise('global-popup', promise)
}
